/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Automation_Use_TemplateInputs */

const cs_settings_automation_use_template = /** @type {(inputs: Settings_Automation_Use_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použít šablonu`)
};

const en_settings_automation_use_template = /** @type {(inputs: Settings_Automation_Use_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use template`)
};

/**
* | output |
* | --- |
* | "Use template" |
*
* @param {Settings_Automation_Use_TemplateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_automation_use_template = /** @type {((inputs?: Settings_Automation_Use_TemplateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Automation_Use_TemplateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_automation_use_template(inputs)
	return cs_settings_automation_use_template(inputs)
});